import { createFileRoute, redirect } from '@tanstack/react-router'
import { AddonsListPage } from '@/pages/Addons/AddonsListPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/addons')({
  component: AddonsListPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/addons')) {
      throw redirect({ to: '/' })
    }
  },
})
